import React from 'react';

export const Button = ({ 
  children, 
  variant = 'default', 
  size = 'default', 
  disabled = false,
  className = '', 
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    default: 'bg-psg-teal text-white hover:bg-psg-teal-600 focus:ring-psg-teal',
    outline: 'border border-psg-teal bg-white text-psg-teal hover:bg-psg-teal-50 focus:ring-psg-teal',
    ghost: 'text-psg-teal hover:bg-psg-teal-100 focus:ring-psg-teal',
    destructive: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    yellow: 'bg-psg-yellow text-psg-teal-900 hover:bg-psg-yellow-400 focus:ring-psg-yellow'
  };
  
  const sizes = {
    default: 'px-4 py-2 text-sm',
    sm: 'px-3 py-1.5 text-xs',
    lg: 'px-6 py-3 text-base'
  };
  
  return (
    <button
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};